<template>

  <br>
  <br>
  <br>
  <br>
  <br>



<div class="position-fixed bottom-0 w-100 max_width">

  <menu class="menu">

    <router-link :to="{name:'AuctionsPage'}" id="bids" class="menu__item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icon bi bi-hammer" viewBox="0 0 16 16">
        <path d="M9.972 2.508a.5.5 0 0 0-.16-.556l-.178-.129a5 5 0 0 0-2.076-.783C6.215.862 4.504 1.229 2.84 3.133H1.786a.5.5 0 0 0-.354.147L.146 4.567a.5.5 0 0 0 0 .706l2.571 2.579a.5.5 0 0 0 .708 0l1.286-1.29a.5.5 0 0 0 .146-.353V5.57l8.387 8.873A.5.5 0 0 0 14 14.5l1.5-1.5a.5.5 0 0 0 .017-.689l-9.129-8.63c.747-.456 1.772-.839 3.112-.839a.5.5 0 0 0 .472-.334"/>
      </svg>
    </router-link>

    <router-link :to="{name:'CategoryPage',params:{cid:0}}" id="category" class="menu__item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icon bi bi-grid-fill" viewBox="0 0 16 16">
        <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/>
      </svg>
    </router-link>

    <router-link :to="{name:'HomePage'}" id="home" class="menu__item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icon bi bi-house-door-fill" viewBox="0 0 16 16">
        <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
      </svg>
    </router-link>

    <router-link :to="{name:'MyOrders'}" id="orders" class="menu__item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icon bi bi-bag-check-fill" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0m-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
      </svg>
    </router-link>

    <router-link :to="{name:'ProfilePage'}" id="profile" class="menu__item">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icon bi bi-person-fill" viewBox="0 0 16 16">
        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
      </svg>
    </router-link>

    <div class="menu__border"></div>

  </menu>

  <div class="svg-container">
    <svg viewBox="0 0 202.9 45.5" >
      <clipPath id="menu" clipPathUnits="objectBoundingBox" transform="scale(0.0049285362247413 0.021978021978022)">
        <path  d="M6.7,45.5c5.7,0.1,14.1-0.4,23.3-4c5.7-2.3,9.9-5,18.1-10.5c10.7-7.1,11.8-9.2,20.6-14.3c5-2.9,9.2-5.2,15.2-7
          c7.1-2.1,13.3-2.3,17.6-2.1c4.2-0.2,10.5,0.1,17.6,2.1c6.1,1.8,10.2,4.1,15.2,7c8.8,5,9.9,7.1,20.6,14.3c8.3,5.5,12.4,8.2,18.1,10.5
          c9.2,3.6,17.6,4.2,23.3,4H6.7z"/>
      </clipPath>
    </svg>
  </div>


</div>

</template>


<script>

import {useRoute} from "vue-router";
import $ from "jquery"

export default {

  name: 'BottomNavigation',

  setup() {

    let page = useRoute().name

    setTimeout(()=>{

      if (page === 'HomePage'){
        $("#home").addClass('active')
      }else if(page === 'ProfilePage'){
        $("#profile").addClass('active')
      }else if(page === 'AuctionsPage'){
        $("#bids").addClass('active')
      }else if(page === 'MyOrders'){
        $("#orders").addClass('active')
      }else if(page === 'CategoryPage'){
        $("#category").addClass('active')
      }

      "use strict";

      const body = document.body;
      const menu = body.querySelector(".menu");
      const menuItems = menu.querySelectorAll(".menu__item");
      const menuBorder = menu.querySelector(".menu__border");
      let activeItem = menu.querySelector(".active");

      function clickItem(item) {

        menu.style.removeProperty("--timeOut");

        if (activeItem == item) return;

        if (activeItem) {
          activeItem.classList.remove("active");
        }


        item.classList.add("active");
        activeItem = item;
        offsetMenuBorder(activeItem, menuBorder);


      }

      function offsetMenuBorder(element, menuBorder) {
        const offsetActiveItem = element.getBoundingClientRect();
        const offsetMenu = menu.getBoundingClientRect();
        const left = Math.floor(offsetActiveItem.left - offsetMenu.left - (menuBorder.offsetWidth - offsetActiveItem.width) / 2) + "px";
        menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
      }

      offsetMenuBorder(activeItem, menuBorder);

      menuItems.forEach((item, index) => {

        item.addEventListener("click", () => clickItem(item, index));

      })

      window.addEventListener("resize", () => {
        offsetMenuBorder(activeItem, menuBorder);
        menu.style.setProperty("--timeOut", "none");
      });

    },.1)



    return {
      page,
      // push_page,
    }
  }
}
</script>


<style scoped>

.menu{
  margin: 0;
  display: flex;
  width: 100%;
  height: 5em;
  max-width: 70rem;
  //font-size: 1.5em;
  //padding: 0 2.85em;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: #2F3A96;
  overflow-x: clip;
}

.menu__item{
  all: unset;
  flex-grow: 1;
  z-index: 100;
  display: flex;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  align-items: center;
  //will-change: transform;
  justify-content: center;
  //padding: 0.55em 0 0.85em;
  transition: transform var(--timeOut , var(--duration));

}

.menu__item::before{
  content: "";
  z-index: -1;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  position: absolute;
  transform: scale(0);
  transition: background-color var(--duration), transform var(--duration);
}

.menu__item.active {
  transform: translate3d(0, -8px , 0);
}

.menu__item.active::before{
  transform: scale(1);
  background-color: white;
  color: #2F3A96 !important;
}

.icon{
  width: 2em;
  height: 2em;
  stroke: white;
  fill: transparent;
  //stroke-width: 1pt;
  stroke-miterlimit: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 400;
}

.menu__item.active .icon {
  //animation: strok 1.5s reverse;
  stroke: #2F3A96 !important;
}

@keyframes strok {
  100% {

    stroke-dashoffset: 400;

  }
}

.menu__border{
  left: 0;
  bottom: 90%;
  width:12em;
  height: 2.5em;
  position: absolute;
  clip-path: url(#menu);
  will-change: transform;
  background-color: #2F3A96;
  transition: transform var(--timeOut , var(--duration));
}

.svg-container {
  width: 0;
  height: 0;
}


@media screen and (min-width: 700px) {
  .menu{
    font-size: 1rem!important;
  }
}



</style>